<template>
<div class="chapter">
<div class="inner_page">
<p><br/></p>
<h3 class="c3" id="pgepubid00004">PREFACE.</h3>
<p><br/></p>
<p class="noindent">MY DEAR LADS,</p>
<p>This time only a few words are needed, for the story speaks for itself. My object has been rather to tell you a tale of interest than to impart historical knowledge, for the facts of the dreadful time when "the terror" reigned supreme in France are well known to all educated lads. I need only say that such historical allusions as are necessary for the sequence of the story will be found correct, except that the Noyades at Nantes did not take place until a somewhat later period than is here assigned to them.</p>
<p class="noindent">Yours sincerely,<br/>
  G.A. HENTY.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main_0001.vue?9cf1e648